/* Component Dependencies */
var chapterNavigationTemplate = require('templates/chapterNavigation.hbs');
var AriesComponent = require('libs/aries-component');
var _ = require('lodash');

AriesComponent.create({

	type: 'chapterNavigation',

	template: {
		'chapterNavigation': chapterNavigationTemplate
	},

	defaults: {
		SCROLL_TIME: 1000,
		SCROLL_RATE: 0.3,
		SELECT_CHAPTER: '.js-chapter-nav-anchor'
	},

	bindEvents: function ($) {
		var _self = this;
		_self.$ = $;
		_self.$window = _self.$(window);
		_self.$window.on('load', _self.onPageLoad.bind(_self));
	},

	/**
		* On page load initialise component state and conditionally bind events
		* @return {void}
		*/
	onPageLoad: function () {
		var _self = this;
		_self.scrollHeight = 0;
		_self.viewHeight = 0;
		_self.$body = _self.$(document.body);
		_self.$stickyNav = _self.$body.find('#stickySummary');
		_self.offsetBase = 0;
		_self.$activeTarget = null;
		_self.offsets = [];
		_self.avoidPointerEvents = false;
		_self.$targets = _self.$body.find(_self.defaults.SELECT_CHAPTER)
			.has('h2');

		if (_self.$targets.length) {
			_self.$navList = _self.$el.find(".l-navbar-nav");
			_self.$navtrigger = _self.$el.find(".l-navbar-trigger");
			_self.createNavLinks();
			_self.updatePosition();
			_self.onPageScroll();
			_self.$window.on('scroll', _.throttle(_self.onPageScroll.bind(_self), _self.defaults.SCROLL_TIME));
			_self.$navList.on('click', 'li',  _self.onNavClick.bind(_self));
			_self.$navtrigger.on('mouseenter', _self.onMouseEnter.bind(_self));
			_self.$el.on('mouseleave', function(event){
				if( event.relatedTarget ){
					_self.onMouseLeave(event);
				}
			});
		}
	},

	/**
		* Build navigation link for each section dividers which has the chapter XM config = true
		* @return {void}
		*/
	createNavLinks: function () {
		var _self = this, navItemTemplate, navItemListTemplate, navItemTemplateFn, __ = _.runInContext();
		navItemTemplate =
			'<li class="t-nav-item l-display-flex l-flex-nowrap l-flex-col l-right-align l-justify-flex-center">' +
			'<a class="t-nav-link t-font-m t-cursor-default l-overflow-hidden t-uppercase" tabindex="-1" href="#"><%= text %></a>' +
			'</li>';
		navItemTemplateFn = __.template(navItemTemplate);
		navItemListTemplate = _self.$targets.map(function (index, target) {
			return navItemTemplateFn({text: _self.$(target).find("h2").first().text()});
		}).get().join("");
		_self.$links = _self.$navList.html(navItemListTemplate).children();
	},

	/**
		* Update top offset of each section dividers which has the chapter XM config = true
		* @return {void}
		*/
	updatePosition: function () {
		var _self = this;

		_self.offsets = [];
		_self.scrollHeight = _self.$body.height();

		_self.offsetBase = _self.$stickyNav.hasClass('is-sticky-top') ? _self.$stickyNav.height() : 0;
		_self.viewHeight = _self.$window.height() - _self.offsetBase;

		// populate current offset of target elements
		_self.offsets = _self.$targets
			.map(function () {
				return _self.$(this).offset().top;
			});
	},

	/**
		* On page scroll, highlight the current active link
		* @return {void}
		*/
	onPageScroll: function () {
		var _self = this, index, scrollTop;
		scrollTop = _self.$window.scrollTop();

		if (_self.scrollHeight !== _self.$body.height()) {
			_self.updatePosition();
		}

		if (_self.$activeTarget && (scrollTop + _self.offsetBase) < _self.offsets[0]) {
			_self.$activeTarget = null;
			_self.clear();
		}

		var offsetsInView = _self.offsets.filter(function (index, offset) {
			return (offset < (scrollTop + _self.viewHeight));
		});

		if (offsetsInView.length) {
			for (index = 0; index < offsetsInView.length - 1; index++) {
				if (_self.$activeTarget !== _self.$targets.eq(index) &&
					(offsetsInView[index] - _self.offsetBase > scrollTop)) {
					break;
				}
			}
			_self.activate(index);
			_self.showNav();
		} else {
			_self.hideNav();
		}

	},

	/**
		* On page scroll, show/hide chapter navigation indicator and highlight the current active link
		* @param {Object} event Event object is passed
		* @return {void}
		*/
	onNavClick: function (event) {
		var _self = this, position;
		event.stopPropagation();
		event.preventDefault();
		event.currentTarget.focus();
		_self.avoidPointerEvents = true;
		position = _self.offsets[_self.$links.index(event.currentTarget)];
		_self.transitioning = true;
		_self.$("html").stop().animate({scrollTop: position}, _self.getDuration(position));
	},

	/**
		* On mouse over fade in chapter navigation link
		* @return {void}
		*/
	onMouseEnter: function () {
		var _self = this;
		if(!(_self.avoidPointerEvents)) {
			_self.$el.addClass('fade-in');
		}
	},

	/**
		* On mouse leave fade out chapter navigation link
		* @return {void}
		*/
	onMouseLeave: function () {
		var _self = this;
		_self.avoidPointerEvents = false;
		_self.$el.removeClass('fade-in');
	},

	/**
		* Return normalized scroll rate depending on the distance of the target element
		* @param {Object} target Position of the scroll element
		* @return {number} normalized scroll rate
		*/
	getDuration: function (target) {
		var _self = this, currentTop;
		currentTop = _self.$window.scrollTop();
		return Math.abs(currentTop - target) * _self.defaults.SCROLL_RATE;
	},

	/**
		* Highlight the current active link
		* @param {number} index of the navigation list link
		* @return {void}
		*/
	activate: function (index) {
		var _self = this;
		_self.clear();
		_self.$activeTarget = _self.$targets.eq(index);
		_self.$links.eq(index).addClass('active');
	},

	/**
		* Clear the active navigation link
		* @return {void}
		*/
	clear: function () {
		var _self = this;
		_self.$links.filter('.active').removeClass('active');
	},

	/**
		* Show chapter navigation
		* @return {void}
		*/
	showNav: function () {
		var _self = this;
		_self.$el.addClass("in-view")
			.attr("aria-hidden", "false");
	},

	/**
		* Hide chapter navigation
		* @return {void}
		*/
	hideNav: function () {
		var _self = this;
		_self.$el.removeClass("in-view")
			.attr("aria-hidden", "true");
	}

});
